<template>
  <div class="questionnaire">
    <Header type="questionnaire"></Header>
    <div class="block">
      <router-view />
    </div>
    <Progress></Progress>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Progress from '@/components/Progress.vue'
export default {
  name: "Questionnaire",
  components: {
    Header,
    Progress,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.questionnaire{
  height: 100vh;
}
.block{
  height: 100%;
}
</style>
